// Bank's bank_type constants (follow api Bank::BANK_TYPE val except for 0)
export enum BankTypes {
  OTHERS = 0,
  BANK = 1,
  PAYMENT_GATEWAY = 2,
  EWALLET = 3,
  PAYMENT_GATEWAY_CRYPTO = 5,
  CRYPTO = 6,
  PAYID = 8
}
